import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ASSIGNMENT_FEATURE_KEY, AssignmentState } from './assignment.reducer';

export const selectAssignmentState = createFeatureSelector<AssignmentState>(ASSIGNMENT_FEATURE_KEY);

export const selectAssignments = createSelector(selectAssignmentState, (state) => state?.data ?? null);
export const selectAssignmentsQuery = createSelector(selectAssignmentState, (state) => state?.query ?? null);
export const selectAssignmentsLoading = createSelector(selectAssignmentState, (state) => state?.loading ?? false);
export const selectAssignmentsError = createSelector(selectAssignmentState, (state) => state?.error ?? null);
export const selectLastAssignment = createSelector(
  selectAssignments,
  // Skip soft-deleted therapies — the "last assigned therapy" must be an active one.
  (assignments) => assignments?.find((assignment) => assignment.deleted == null) ?? null,
);
